import { useState } from 'react';
import { auth } from '../Services/firebase';
import { sendPasswordResetEmail } from 'firebase/auth';
import { Modal, Button, Form } from 'react-bootstrap';
import './css/AccountForgottenPassword.css';

export function AccountForgottenPassword({ show, onHide }: {
    show: boolean;
    onHide: () => void;
}) {
    const [email, setEmail] = useState('');
    const [message, setMessage] = useState<string | null>(null);
    const [error, setError] = useState<string | null>(null);

    const handleReset = async (e: React.FormEvent) => {
        e.preventDefault();
        setError(null);

        try {
            await sendPasswordResetEmail(auth, email);
            setMessage("Hey, we’ve skittered a reset link into your inbox!");

        } catch (err: unknown) {
            if (err instanceof Error) {
                setError(err.message);
            } else {
                setError('Unexpected error occurred.');
            }
        }
    };

    return (
        <Modal show={show} onHide={onHide} centered>
            <Modal.Header closeButton>
                <Modal.Title>Reset Your Password</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <Form onSubmit={handleReset}>
                    <Form.Group className="mb-3" controlId="formEmail">
                        <Form.Label>Email address</Form.Label>
                        <Form.Control
                            type="email"
                            placeholder="you@email.com"
                            value={email}
                            onChange={(e) => setEmail(e.target.value)}
                            required
                        />
                    </Form.Group>

                    {error && <div className="text-danger mb-2">{error}</div>}
                    {message && <div className="text-success mb-2">{message}</div>}

                    <Button variant="primary" type="submit">Send Reset Link</Button>
                </Form>
            </Modal.Body>
        </Modal>
    );
}
